import { initializeSentry } from "./Sentry";
import { initializeMixPanel, track } from "./MixPanel";

export const initializeThirdPartyServices = () => {
    // Initialize Sentry
    initializeSentry();
    initializeMixPanel();
    // Add other third-party service initializations here as needed
};
